var timestamp = new Date().getTime();

//RoadInfo
var json_road_info = '/json/road2.json';

//大涌谷満空情報
var json_owaku = './cmn/js/json/json_idx_owaku.php';

//国道１号宮ノ下
var json_miyanoshita = './cmn/js/json/json_idx_miyanoshita.php';


//++++++ 小田急 JSON ++++++++
// TOP
var json_odakyu_top = './cmn/js/json/json_odakyu_top.php';
// GROUP
var json_odakyu_group = './cmn/js/json/json_odakyu_group.php';
// ALL
var json_odakyu_all = './cmn/js/json/json_odakyu_all.php';

//++++++ 小田急 配列 +++++++
var odakyu_top_array = [];
var odakyu_group_array = [];
var odakyu_all_array = [];





//++++++ 伊豆箱根 JSON ++++++++
// GROUP
var json_izuhako_group = './cmn/js/json/json_izuhako_group.php';
// ALL
var json_izuhako_all = './cmn/js/json/json_izuhako_all.php';

//++++++ 伊豆箱根  配列 +++++++
var izuhako_all_array = [];
var izuhako_group_array = [];


var TABLET_WIDTH = 768;
//ウィンドウ幅
var window_width = window.innerWidth;


// ++++ 各社　ジャンプ先URL ****

//小田急
var link_odakyu_all = "https://www.hakonenavi.jp/transportation/";
//@@@ 伊豆箱根

//伊豆箱根バス
var link_izuhako_1 = "http://www.izuhakone.co.jp/bus/";
//芦ノ湖遊覧船
var link_izuhako_2 = "http://www.izuhakone.co.jp/hakone-yuransen/";
//駒ケ岳ロープウェー
var link_izuhako_3 = "https://www.princehotels.co.jp/amuse/hakone-en/ropeway/";




$(function () {


	//+++++++ 大涌谷 JSON読み込み +++++++++
	$.ajax({
			url: json_owaku,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var parking_status = data[0].parking_status;
				var parking_status_min = parking_status.charAt(0);

				var waiting_min = data[0].waiting_min;
				var parking_comment = data[0].parking_comment;

				// ** を <strong>に変換
				parking_comment = parking_comment.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				// \r\n を<br>に変換
				parking_comment = parking_comment.replace(/\r?\n/g, '<br>');
				// URLを自動リンク
				var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
				parking_comment = parking_comment.replace(exp, "<a href='$1' target='_blank'>$1</a>");



				// ラベルのカラー変更
				if (parking_status_min == '満') {
					$('.park_info_label_inner').addClass('label_man');
				} else if (parking_status_min == '混') {
					$('.park_info_label_inner').addClass('label_kon');
				} else if (parking_status_min == '空') {
					$('.park_info_label_inner').addClass('label_kuu');
				} else if (parking_status_min == '閉') {
					$('.park_info_label_inner').addClass('label_hei');
				}

				// データを書き込み
				$('.js-parking_status').html(parking_status_min);
				$('.js-waiting_min').html(waiting_min);
				$('.js-parking_comment').html(parking_comment);




			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 一般道路


	//+++++++ 宮ノ下 JSON読み込み +++++++++
	$.ajax({
			url: json_miyanoshita,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var traffic_min = data[0].traffic_min;
				traffic_min = Number(traffic_min);

				var alternative_route_comment1 = data[0].alternative_route_comment_1;
				// ** を <strong>に変換
				alternative_route_comment1 = alternative_route_comment1.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				// \r\n を<br>に変換
				alternative_route_comment1 = alternative_route_comment1.replace(/\r?\n/g, '<br>');

				var alternative_route_comment2 = data[0].alternative_route_comment_2;
				// ** を <strong>に変換
				alternative_route_comment2 = alternative_route_comment2.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				// \r\n を<br>に変換
				alternative_route_comment2 = alternative_route_comment2.replace(/\r?\n/g, '<br>');

				var spot_comment = data[0].spot_comment;

				//var spot_comment_dum ="・箱**根小涌**園 元湯 森の湯[https://www.morino-yu.com/]\r\n・箱根小涌園ユネッサン[https://www.yunessun.com/]\r\n・炉端焼き「紅葉」（ユネッサン敷地内）[https://www.yunessun.com/facility/momiji.html]\r\n・箱根 彫刻の森美術館[https://www.hakone-oam.or.jp/]\r\n・富士屋ホテル[https://www.fujiyahotel.jp/]\r\nﾍﾞｰｶﾘｰ＆ｽｲｰﾂ ﾋﾟｺｯﾄ/ﾗｳﾝｼﾞ/ﾎﾃﾙ･ｼｮｯﾌﾟ/ﾎﾃﾙ･ﾐｭｰｼﾞｱﾑ\r\n・箱根小涌園ユネッサン[https://www.yunessun.com/]";

				//spot_comment = spot_comment_dum;

				//改行コードを変換
				spot_comment = spot_comment.replace(/\r/g, '');
				// ** を <strong>に変換
				//spot_comment=spot_comment.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>');
				//リンクをタグに変換
				spot_comment = spot_comment.replace(/(.*?)\[(.*?)\]/g, '<a href="$2" target="_blank">$1</a>');
				// \n を<br>に変換
				spot_comment = spot_comment.replace(/\n/g, '<br>');


				//console.log(spot_comment);


				// ** を <strong>に変換
				//spot_comment=spot_comment.replace(/^\*\*(.*?)\*\*/g,'<strong>$1</strong>');
				// \r\n を<br>に変換
				//	spot_comment=spot_comment.replace(/\r?\n/g,'<br>');

				//リンクを抽出　変換
				//spot_comment=spot_comment.replace(/(.*?)\[(.*?)\]/g,'<a href="$2" target="_blank">$1</a><br>');
				//spot_comment=spot_comment.replace(/_blank"><br>/g,'_blank">');
				//spot_comment=spot_comment.replace(/<br><br>/g,'<br>');


				//20分以下か判断
				if (traffic_min <= 20) {
					$('.js-traffic_min').html('<div class=tsujyo">平常通り</div>');
				} else {
					$('.js-traffic_min').html('約<span>' + traffic_min + '</span>分');
				}

				$('.js-alternative_route_comment1').html(alternative_route_comment1);
				$('.js-alternative_route_comment2').html(alternative_route_comment2);
				$('.js-spot_comment').html(spot_comment);




			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 一般道路






	//+++++++ 一般道路 JSON読み込み +++++++++
	$.ajax({
			url: json_road_info,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {
				//alert('あああ')
				var event_info = data.event_info;


				if (event_info == 'true') {
					$('.js-road-info').text('規制あり');
				} else {
					$('.js-road-info').text('規制なし');
				}


			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 一般道路





	//+++++++ 小田急　グループ JSON読み込み +++++++++
	$.ajax({
			url: json_odakyu_group,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var view_html = '';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;


				for (var i = 0; i < json_length; i++) {


					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var group_comment = data[i].group_comment
					// ** を <strong>に変換
					group_comment = group_comment.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment = group_comment.replace(/\r?\n/g, '<br>');

					//console.log(group_name);
					//console.log(group_comment);


					if (group_comment) {

						view_html += '<dt><a href="' + link_odakyu_all + '" target="_blank">' + group_name + '</a></dt>';
						view_html += '<dd>' + group_comment + '</dd>';

						counter++;
						odakyu_group_array.push(group_cd);
					}


				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-odakyu-top').html(view_html);
				}





			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 小田急　グループ





	//+++++++ 伊豆箱根　グループ JSON読み込み +++++++++
	$.ajax({
			url: json_izuhako_group,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var view_html = '';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;

				for (var i = 0; i < json_length; i++) {


					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var group_comment = data[i].group_comment
					// ** を <strong>に変換
					group_comment = group_comment.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment = group_comment.replace(/\r?\n/g, '<br>');

					if (group_comment) {
						if (group_name == '伊豆箱根バス') {
							view_html += '<dt><a href="' + link_izuhako_1 + '" target="_blank">' + group_name + '</a></dt>';
						} else if (group_name == '芦ノ湖遊覧船') {
							view_html += '<dt><a href="' + link_izuhako_2 + '" target="_blank">' + group_name + '</a></dt>';
						} else if (group_name == '箱根駒ケ岳ロープウェー') {
							view_html += '<dt><a href="' + link_izuhako_3 + '" target="_blank">' + group_name + '</a></dt>';
						} else {
							view_html += '<dt>' + group_name + '</dt>';
						}

						view_html += '<dd>' + group_comment + '</dd>';
						counter++;
						izuhako_group_array.push(group_cd);
					}

				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-izuhako-top').html(view_html);
				}


				//console.log(view_html);
				//console.log('yes');


			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 伊豆箱根　グループ








});